export class Selectable {
    externalName: string;
    hasCheckbox = true;
    isSelected = false;
    userField = false;

    constructor(value?: Partial<Selectable>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
